import * as React from "react";
const SvgFiRrClarinet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-clarinet_svg__a)">
      <path
        fill="#062147"
        d="M23.035 6.274c-.322-.203-1.004-.482-1.939-.037-.179.085-.395.201-.644.336-.854.461-2.061 1.113-3.452 1.343V7a1 1 0 1 0-2 0v1h-3V7a1 1 0 1 0-2 0v1H7V7a1 1 0 1 0-2 0v1.281c-1.17.295-2.331.776-3.236 1.204A3.1 3.1 0 0 0 0 12.28v.504a3.07 3.07 0 0 0 1.671 2.749C2.981 16.202 4.968 17 7 17h9c1.519 0 3.624 1.046 4.636 1.549l.434.213c.367.176.696.238.979.238.436 0 .765-.15.961-.274.629-.396.989-1.176.99-2.138l.025-8.173c0-.964-.361-1.744-.99-2.141M22 16.582v.003c0 .177-.024.303-.049.381l-.021-.009-.403-.199C20.291 16.144 17.989 15 16.001 15H7c-1.721 0-3.507-.782-4.419-1.248A1.08 1.08 0 0 1 2 12.784v-.504c0-.422.243-.809.619-.986C4.382 10.459 5.937 10 7 10h9c2.314 0 4.247-1.044 5.402-1.667.214-.115.399-.217.554-.29l.021-.009c.024.078.049.203.049.378zM13 12.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 13 12.5m-5 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 8 12.5m10 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 18 12.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-clarinet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrClarinet;
